import mixpanel from "mixpanel-browser";
import Placeholder from "./placeholder";
import React from "react";
import PropTypes from "prop-types";

const context = React.createContext(new Placeholder());

function Provider({ token, ...props }) {
	if (token) {
		mixpanel.init(token);
	}
	const value = token ? mixpanel : new Placeholder();
	return <context.Provider value={ value } { ...props } />;
};

Provider.propTypes = {
	token: PropTypes.string.isRequired,
};

export function useMixpanel(cb) {
	const mixpanel = React.useContext(context);
	React.useEffect(() => {
		cb(mixpanel);
	// eslint-disable-next-line
	}, []);
};

export { Provider };
export default context;
